/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicBranches.internal

import features.publicBranches.models.PublicBranchesModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class PublicBranchesRequest : NetworkRequest() {

    suspend fun getPublicBranches(
        overrideHeaders: Map<String, String>? = null,
        perPage: Int
    ): IOResult<PublicBranchesModel> {
        return safeNetworkCall {
            get(
                endpoint = PublicBranchesEndpoint.replaceInPath(
                    PathParameter("perPage", perPage),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
